/** Estado global del shell (solo UI). El historial ya NO vive aquí: se persiste
 *  en el backend y se consulta por HTTP (APP-003). */

export interface AppState {
  sidebarOpen: boolean
}

export type AppAction =
  | { type: 'TOGGLE_SIDEBAR' }
  | { type: 'SET_SIDEBAR'; open: boolean }

export const initialAppState: AppState = {
  sidebarOpen: true,
}

export function appReducer(state: AppState, action: AppAction): AppState {
  switch (action.type) {
    case 'TOGGLE_SIDEBAR':
      return { ...state, sidebarOpen: !state.sidebarOpen }
    case 'SET_SIDEBAR':
      return { ...state, sidebarOpen: action.open }
    default:
      return state
  }
}
